import { useIsMobile } from "@/hooks/use-mobile";

export const ServiceBannerSkeleton = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="w-full">
      {/* Banner skeleton with gradient background and shadow */}
      <div className="w-full relative overflow-hidden shadow-lg" style={{ height: isMobile ? '200px' : '300px' }}>
        <div className="w-full h-full bg-gradient-to-b from-gray-100 to-gray-300 animate-pulse rounded-b-md border-b border-gray-300"></div>
      </div>
      
      <div className="container mx-auto max-w-5xl px-4">
        {/* Profile image skeleton */}
        <div className="flex justify-center relative z-10" style={{ marginTop: isMobile ? '-64px' : '-80px' }}>
          <div className={`rounded-full border-4 border-white shadow-lg bg-gray-300 animate-pulse ${isMobile ? 'w-24 h-24' : 'w-32 h-32'}`}></div>
        </div>
        
        {/* Business profile skeleton */}
        <div className="mt-4 flex flex-col items-center">
          <div className="h-8 w-48 mb-2 bg-gray-300 animate-pulse rounded-md"></div>
          <div className="h-4 w-32 mb-4 bg-gray-300 animate-pulse rounded-md"></div>
          <div className="h-10 w-40 bg-gray-300 animate-pulse rounded-md"></div>
        </div>
      </div>
    </div>
  );
}; 